import createReactComponent from '../createReactComponent';
export default createReactComponent('crosshair', 'Crosshair', [["path",{"d":"M21 12h-3M6 12H3m9-6V3m0 18v-3m9-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-0"}]]);